import { render, staticRenderFns } from "./settingPassword.vue?vue&type=template&id=2d188238&scoped=true"
import script from "./settingPassword.vue?vue&type=script&lang=js"
export * from "./settingPassword.vue?vue&type=script&lang=js"
import style0 from "./settingPassword.vue?vue&type=style&index=0&id=2d188238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d188238",
  null
  
)

export default component.exports